import { Link, createFileRoute } from "@tanstack/react-router";
import { ArrowLeft } from "lucide-react";

import { ClientTabPage } from "@/features/booking/modules/client-page/client-tab-page";
import { MetricDetail } from "@/features/progress/modules/metric-detail/metric-detail";
import { m } from "@/paraglide/messages.js";

export const Route = createFileRoute("/(private)/trainees/$clientId/progress/$metricId")({
  loader: () => ({ crumb: m.progress_metric_crumb() }),
  component: RouteComponent,
});

function RouteComponent() {
  const { clientId, metricId } = Route.useParams();
  // Stays under the client's header and tabs, so a metric is never a dead end away from its client.
  return (
    <ClientTabPage clientId={clientId} tab="progress">
      <div className="space-y-4">
        <Link
          to="/trainees/$clientId/progress"
          params={{ clientId }}
          className="-ml-2 inline-flex items-center gap-1.5 rounded-lg px-2 py-1 text-sm font-medium text-muted-foreground transition-colors hover:bg-muted/60 hover:text-foreground"
        >
          <ArrowLeft className="size-4" aria-hidden />
          {m.progress_all_metrics()}
        </Link>
        <MetricDetail clientId={clientId} metricId={metricId} />
      </div>
    </ClientTabPage>
  );
}
